import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { environment } from '../../environments/environment';

/**
 * Custom URL Serializer that ensures version query param is always present
 * Works in conjunction with server-side 302 redirect to break cache
 */
@Injectable()
export class VersionUrlSerializer extends DefaultUrlSerializer {
  private readonly VERSION = environment.version;

  parse(url: string): UrlTree {
    const tree = super.parse(url);

    // Add version param if not present or incorrect
    if (tree.queryParams['v'] !== this.VERSION) {
      tree.queryParams = {
        ...tree.queryParams,
        v: this.VERSION,
      };
    }

    return tree;
  }

  serialize(tree: UrlTree): string {
    // Ensure version param is present and correct before serialization
    if (tree.queryParams['v'] !== this.VERSION) {
      tree.queryParams = {
        ...tree.queryParams,
        v: this.VERSION,
      };
    }

    return super.serialize(tree);
  }
}
